<!--
 * @Author: xing.huang
 * @Date: 2021-02-18 15:24:44
 * @LastEditTime: 2021-03-02 15:23:39
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\customPrint\PrintEdit.vue
 * @
-->
<!--
 * @Author: xing.huang
 * @Date: 2021-02-18 15:25:04
 * @LastEditTime: 2021-03-01 17:54:25
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\customPrint\PrintAdd.vue
 * @
-->
<template>
    <div class="add-custom-report">
        
        <el-row :gutter="20" class="">
            <el-col :span="12" :offset="6">
                <el-button type="primary" @click="preview" style="margin-left: 10px;">预览</el-button>
                <el-button type="primary" @click="saveCustomReport">保存</el-button>
                <el-button type="danger" @click="clearCanvas">清空画布</el-button>
            
                <div class="canvas-config">
                    <span>画布大小</span>
                    <input v-model="width" style="width: 50px;" disabled>mm
                    <span> * </span>
                    <input v-model="height" style="width: 50px;" disabled>mm
                </div>
                <div class="canvas-config">
                    <span>画布比例</span>
                    <input v-model="scale" style="width: 50px;"> %
                </div>
            </el-col>
            
        </el-row>
        
        <div style="margin-top:20px;display:flex" :gutter="20">
            <div  style="flex:2">
                <div class="dragArea list-group tag-warp"    @dragstart="handleDragStart">
                    <div class="list-group-item" v-for="(element,index) in list" :key="element.propertyName" draggable :data-index="index">
                        <el-tag class="tag" >
                            <i v-if="element.propertyType==0" class="el-icon-my-text" style="margin-right:6px"></i>
                            <i v-if="element.propertyType==2" class="el-icon-my-qr" style="margin-right:6px"></i>
                            {{ element.propertyName }}
                        </el-tag>
                    </div>
                </div>
            </div>
            <div class="edit-content"  style="margin:0 10px;flex:19">
                <div class="list-warp" :style="{width:maxW+'px',height:maxH+'px',transform: `scale(${parseInt(scale)/100})`}"    @drop="handleDrop" @dragover="handleDragOver" @mousedown="handleMouseDown" @mouseup="deselectCurComponent">
                    <Grid/>
                    <div class="item" v-for="(element,index) in columnList" :key="index" @click="selectCurComponent" @mousedown="handleMouseDownOnShape($event,element)"
                      :style="{left:element.x+'px',top:element.y+'px'}" >
                      <i class="el-icon-my-remove show-del" @click="delItem(element,index)"></i>
                        <el-tag  v-if="element.propertyType==1" :style="{fontSize:element.fieldSize+'px'}">{{ element.propertyName }}</el-tag>
                        <div v-if="element.propertyType==0">
                            <div class="text-componet" :style="{fontSize:element.fieldSize+'px'}" contenteditable v-html="element.propertyName" @blur="handleBlur($event,element)" @input.stop='handleInput($event,element)' placeholder="自定义输入"></div>
                        </div>
                        <div v-if="element.propertyType==2">
                            <QrcodeVue :value="element.propertyName||'test'" :size="element.fieldSize" level="H" ></QrcodeVue>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex:3">
               
                <div v-if="isSelect">
                    <h3>属性</h3>
                    <el-form>
                        <!-- <el-color-picker v-if="key == 'borderColor'" v-model="curComponent.style[key]"></el-color-picker>
                        <el-color-picker v-else-if="key == 'color'" v-model="curComponent.style[key]"></el-color-picker>
                        <el-color-picker v-else-if="key == 'backgroundColor'" v-model="curComponent.style[key]"></el-color-picker> -->
                        <el-form-item label="字体大小">
                            <el-input type="number"  v-model="selectDate.fieldSize" />
                        </el-form-item>
                        <el-form-item label="y坐标">
                            <el-input type="number"  v-model="selectDate.y" />
                        </el-form-item>
                        <el-form-item label="x坐标">
                            <el-input type="number"  v-model="selectDate.x" />
                        </el-form-item>
                        <el-form-item label="内容" v-if="selectDate.propertyType==0">
                            <el-input type="textarea" v-model="selectDate.propertyName" />
                        </el-form-item>
                    </el-form>
                </div>

                <p v-else class="placeholder">请选择组件</p>
            </div>
        </div>

        <PreviewDialog :isShow="isShow" :maxH="Number(maxH)" :maxW="Number(maxW)" :columnList="columnList" ></PreviewDialog>
    </div>
    
</template>

<script>
import Grid from './Grid.vue';
import QrcodeVue from 'qrcode.vue';
import PreviewDialog from './PreviewDialog.vue'
export default {
    name: "CustomReportAddDialog",
    components: {
        QrcodeVue,
        Grid,
        PreviewDialog
    },
    data() {
        return {
            isShow:false,
            scale:100,
            isSelect:false,
            submitForm:{},
            selectDate:{},
            W:true,
            list: [],
            width:0,
            height:0,
            baseData:[],
            columnList:[],
            maxLen:19,
            customPintInfo:{},
        };
    },
    created() {
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    },
    mounted(){
       
        this.customPintInfo = this.$store.state.customPintInfo
        log(this.customPintInfo,123457)
        this.columnList = commonUtils.cloneObj(this.customPintInfo.flowCardTemplatePropertyDtos)
        
        this.columnList.forEach(item=>{
            if(item.propertyType==0){
                item.propertyName = item.text
            }else{
                item.propertyName = item.fieldName
            }
        })
        this.width = this.customPintInfo.width
        this.height = this.customPintInfo.height
        this.loadPropertyList()
    },
    computed:{
        maxH(){
            return commonUtils.mm2px(this.height)
        },
        maxW(){
           return commonUtils.mm2px(this.width) 
        }
    },
    methods: {
        
       

        clearCanvas(){
            this.columnList = []
        },

        async loadPropertyList(){
            let {data,msg,code,message} = await this.$RequestUtil.getAsync({url: '/api/flowCardTemplate/fieldList',params: {},})
            if(code==0){
                this.list = data
                data.forEach(item => {
                    item.fieldSize = 12
                    item.propertyType = 1
                    item.propertyName = item.fieldName
                });
                let defaultArr = [
                    { propertyName: "自定义文字", dragFieldId: -10,propertyType:0,fieldSize:12,fieldName:'自定义文字',fieldCode:'text' },
                    { propertyName: "二维码", dragFieldId: -1,propertyType:2 ,fieldSize:120,fieldName:'二维码',fieldCode:'qr'},
                ]
                this.list = [...defaultArr,...data]
            }else{
                this.$message.error(msg||message)
            }
        },
        
        handleDragStart(e) {
            e.dataTransfer.setData('index', e.target.dataset.index)
        },

        handleDrop(e) {
            e.preventDefault()
            e.stopPropagation()
            const component = commonUtils.cloneObj(this.list[e.dataTransfer.getData('index')])
            component.y = e.offsetY
            component.x = e.offsetX
            log(e)
            this.columnList.push(component)
            component.pId = this.generateID()
        },

        generateID(){
            return new Date().getTime()+ '' + Number.parseInt(Math.random*1000) 
        },

        handleDragOver(e) {
            e.preventDefault()
            e.dataTransfer.dropEffect = 'copy'
        },

        handleInput(ev,item){
            // item.propertyName = ev.target.innerText
        },
        handleBlur(ev,item){
            item.propertyName = ev.target.innerText
        },

        handleMouseDown() {
            this.isSelect = false
        },

        deselectCurComponent() {
            this.isSelect = false
        },

        handleMouseDownOnShape(e,item) {
            // this.$store.commit('setClickComponentStatus', true)
            if (item.propertyType != 0) {
                e.preventDefault()
            }
            
            e.stopPropagation()
            this.selectDate = item
            this.isSelect = true
            const pos = item
            const startY = e.clientY
            const startX = e.clientX
            // 如果直接修改属性，值的类型会变为字符串，所以要转为数值型
            const startTop = Number(pos.y)
            const startLeft = Number(pos.x)
            
            // 如果元素没有移动，则不保存快照
            
            let targetH = e.target.clientHeight
            let targetW = e.target.clientWidth
            const move = (moveEvent) => {
                const curX = moveEvent.clientX
                const curY = moveEvent.clientY
                pos.y = curY - startY + startTop
                pos.x = curX - startX + startLeft
                if(pos.y<0){
                    pos.y = 0
                }
                if(pos.y>this.maxH-targetH){
                    pos.y = this.maxH - targetH
                }
                if(pos.x<0){
                    pos.x = 0
                }
                if(pos.x>this.maxW-targetW){
                    pos.x = this.maxW - targetW
                }
            }

            const up = () => {
                
                document.removeEventListener('mousemove', move)
                document.removeEventListener('mouseup', up)
            }

            document.addEventListener('mousemove', move)
            document.addEventListener('mouseup', up)
        },

        selectCurComponent(e) {
            // 阻止向父组件冒泡
            e.stopPropagation()
            e.preventDefault()
            this.isSelect = true
            // this.$store.commit('hideContextMenu')
        },

        delItem(item,index){
            this.columnList.splice(index,1)
        },
        
        saveCustomReport(){
            this.columnList.forEach(item=>{
                if(item.propertyType==0){
                    item.text = item.propertyName
                }
            })
            this.customPintInfo.propertyVOS  = this.columnList
            delete this.customPintInfo.description
            delete this.customPintInfo.flowCardTemplateName
            delete this.customPintInfo.workshopIds
            delete this.customPintInfo.orientation
            delete this.customPintInfo.width
            delete this.customPintInfo.height
            this.$RequestUtil.post({
                url: '/api/flowCardTemplate/update',
                params: {...this.customPintInfo},
                success:res=>{
                    if(res.code==0){
                        this.$message.success('修改成功')
                        this.$router.push({path: "/Production/CustomPrint"})
                        this.$store.commit("delete_tabs", `/Production/CustomEditPrint`);
                    }else{
                        this.$message.error(res.msg||res.message)
                    }
                }
            })
        },

        reViewCustomReport(){

        },

        preview(){
            this.isShow = true
        },
    }
};
</script>
<style scoped>
.edit-content{
    overflow: auto;
    background: rgba(204,204,204,0.1);
    width: 1320px;
    height: 752px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.text-componet{
    border: 1px solid #ccc;
    padding: 0px 6px 0px 2px;
}
.canvas-config {
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    color: #606266;
}
.warp{
    border: 1px solid red;
    margin-bottom: 10px;
}
.tag-warp{
    border: 1px solid #dcdfe6;
    min-height: 200px;
    min-width: 130px;
}
.tag{
    cursor: pointer;
    margin: 6px 10px;
}

.list-warp .item{
    position: absolute;
}




.list-warp{
   border: 1px solid red;
   position: relative;
   background: #fff;
   box-sizing: border-box;
}
.head .icon-del{
    display: none;
}
.head:hover .icon-del{
    display: block;
}
.el-icon-my-fn{
    position: absolute;
    top: 14px;
    right: -1px;
}
.menu-item{
    /* width: 19px; */
    position: absolute;
    top: 16px;
    right: -1px;
}
.sub-item{
    display: none;
    padding: 10px 6px;
    border-left: 1px solid #dcdfe6;
    line-height: 46px;
    border-bottom: 1px solid #dcdfe6;
}
.el-icon-my-fn:hover{
    background-position: top right;
    background-size: 19px;
}

.value{
    display: inline-block;
}
.item .show-del{
    display: none;
    position: absolute;
    top: -12px;
    right: -12px;
}
.item:hover .show-del{
    display: block;
}
</style>
<style >
.add-custom-report .el-menu-item.is-active {
    background-color: #409EFF;
    color: #fff;
}
.add-custom-report .el-tag--small {
    height: 18px;
    line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/customPrint/PrintEdit.vue